import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: 'Deposit {currencySymbol}',

  firstInfoValueTitle: 'Your balance in SSAP',
  secondInfoValueTitle: 'Your wallet balance',
  graphDotName: 'APY',
});
